import { Pipe, PipeTransform } from '@angular/core';

import { ItemColorKey, itemsColors } from '@core/models/colors.model';

export type ColorOfIndexType = 'tailwind' | 'hex' | 'name';

@Pipe({ name: 'colorOfIndex' })
export class ColorOfIndex implements PipeTransform {
  private readonly _customColors = itemsColors;
  private readonly _tailwindPalette: string[] = [
    'slate',
    'gray',
    'zinc',
    'neutral',
    'stone',
    'red',
    'orange',
    'amber',
    'yellow',
    'lime',
    'green',
    'emerald',
    'teal',
    'cyan',
    'sky',
    'blue',
    'indigo',
    'violet',
    'purple',
    'fuchsia',
    'pink',
    'rose'
  ];

  transform(
    index: number | string,
    options?: {
      typeOfResult?: ColorOfIndexType;
      color?: string | ItemColorKey;
      shade?: string;
    }
  ): string {
    if (typeof index === 'string') {
      index = parseInt(index, 10);
    }

    if (isNaN(index)) {
      if (options?.color) {
        return (
          this._customColors[options.color as ItemColorKey] ||
          this._customColors['darkGrey']
        );
      }
      return '#000';
    }

    if (index < 0) {
      return '#000';
    }

    if (!options) {
      index = index % this._tailwindPalette.length;
      return `var(--color-${this._tailwindPalette[index]}-500)`;
    }

    const { typeOfResult, shade, color } = options;

    const { keys, values } = Object.entries(this._customColors).reduce(
      (acc, [key, value]) => {
        acc.keys.push(key);
        acc.values.push(value);
        return acc;
      },
      { keys: [], values: [] } as { keys: string[]; values: string[] }
    );

    if (typeOfResult === 'hex') {
      if (!color || color === '') {
        index = index % keys.length;
        return values[index];
      }

      return this._customColors[color as ItemColorKey] || this._customColors['darkGrey'];
    } else if (typeOfResult === 'name') {
      index = index % keys.length;
      return keys[index];
    } else {
      if (color && color !== '') {
        return color;
      }

      index = index % this._tailwindPalette.length;
      return !options?.shade
        ? `var(--color-${this._tailwindPalette[index]}-500)`
        : `var(--color-${this._tailwindPalette[index]}-${shade})`;
    }
  }
}
